import type { RouteRecordRaw } from 'vue-router'
import { asyncRoutes } from './routes'

/** 生成跳转外部授权时需要拼接完整的重定向路径的路由 */
const getFullRecirectPaths = (
  routes: RouteRecordRaw[],
  res: string[] = [],
  prefix = ''
): string[] => {
  routes.map((item) => {
    if (item.children && item.children.length > 0) {
      getFullRecirectPaths(item.children, res, `${prefix}${item.path}`)
    }
    if (item.meta?.fullRedirectPath) {
      const p = prefix && !item.path.startsWith('/') ? `${prefix}/${item.path}` : item.path
      res.push(p)
    }
  })
  return res
}
const AUTH_FULL_ROUTES: Set<string> = new Set(getFullRecirectPaths(asyncRoutes))

/**
 * @description 跳转外部授权时是否需要拼接完整的重定向路径的路由
 * @param path 目标路径
 * @returns
 */
export const isFullRedirectPath = (path: string): boolean => {
  return AUTH_FULL_ROUTES.has(path)
}
export default AUTH_FULL_ROUTES
